import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getSortedSections, getArticlesForSection } from '../../config/documentation';
import StaticDocumentationViewer from '../../components/docs/StaticDocumentationViewer';
import AIChatCard from '../../components/aiChat/AiChatCard';
import './DocumentationPage.css';

/**
 * Documentation Page
 * Main page for user-facing help documentation using RAG system
 */
function DocumentationPage() {
  const { section } = useParams();
  const [selectedSection, setSelectedSection] = useState(section || 'getting-started');
  const [showChat, setShowChat] = useState(false);

  const sections = getSortedSections().filter(s => (getArticlesForSection(s.id) || []).length > 0);

  const handleSectionChange = (sectionId) => {
    setSelectedSection(sectionId);
  };

  const handleArticleSelect = () => {
  };

  return (
    <div className="documentationPage">
      {/* Header */}
      <header className="docsHeader">
        <h1 className="docsPageTitle">📚 Documentation</h1>
        <p className="docsPageSubtitle">
          Learn how to use DocuHounds features and get the most out of your academic assistant
        </p>
      </header>

      <div className="docsLayout">
        {/* Sidebar */}
        <aside className="docsSidebar">
          <nav className="docsSections">
            {sections.map((sec) => (
              <button
                key={sec.id}
                data-section={sec.id}
                className={`docsSectionBtn ${selectedSection === sec.id ? 'active' : ''}`}
                onClick={() => handleSectionChange(sec.id)}
              >
                <span className="docsSectionIcon">{sec.icon}</span>
                <div className="docsSectionInfo">
                  <div className="docsSectionName">{sec.name}
                    {sec.id === 'getting-started' && (
                      <span className="docsRecommendedBadge">Recommended</span>
                    )}
                  </div>
                  <div className="docsSectionDesc">{sec.description}</div>
                </div>
              </button>
            ))}
          </nav>

          <div className="docsSidebarFooter">
            <button
              className="docsAiChatToggle"
              onClick={() => setShowChat(!showChat)}
            >
              {showChat ? '📖 Hide' : '💬 Ask AI'} About Docs
            </button>
          </div>
        </aside>

        {/* Main Content */}
        <main className="docsMain">
          <StaticDocumentationViewer
            selectedSection={selectedSection}
            onSelectArticle={handleArticleSelect}
          />

          {/* AI Chat Panel */}
          {showChat && (
            <div className="docsAiChatPanel">
              <AIChatCard 
                context="documentation"
              />
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default DocumentationPage;
